var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-responsive-timeline",style:(_vm.cssVariablesPatched)},[_c('ul',{style:({
      display: 'grid',
      gridTemplateAreas: _vm.isSmallScreen ? _vm.gridTemplateAreasVertical : _vm.gridTemplateAreasHorizontal,
      gridTemplateRows: _vm.isSmallScreen ? ("repeat(" + (_vm.items.length) + ", 150px)") : '30px 30px 120px 120px',
      gridTemplateColumns: _vm.isSmallScreen ? '30px 30px auto' : ("repeat(" + (_vm.items.length) + ", 1fr)"),
    })},[_vm._l((_vm.sortedItems),function(item,index){return [_c('li',{key:((item.title) + " " + (item.subtitle)),style:({
          gridArea: ("evt" + index),
          position: 'relative',
          padding: 0
        })},[_c('span',{staticClass:"event-wrapper"},[_c('p',{staticClass:"title",style:(_vm.titleStyles)},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle",style:(_vm.subtitleStyles)},[_vm._v(_vm._s(item.subtitle))])])])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b7e1f90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueResponsiveTimeline.vue
// module id = 548
// module chunks = 1